<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="card mb-4">
            <h5>Payment</h5>
            <div class="card-body">
                <div class="row">
                    <PaymentListTableComponent :payments="payments" />
                </div>
            </div>
        
        </div>
    </div>
    
</template>

<script>
    import axios from 'axios';
    import PaymentListTableComponent from '../components/PaymentListTable.vue';
    export default {
        components: { PaymentListTableComponent },
        data() {
            return {
                payments: [],
                loading: true,
                error: null,
                pollingInterval: null
            };
        },
        created() {
            this.fetchPaymentData();
        },
        mounted() {
            // Start polling every 10 seconds
            this.pollingInterval = setInterval(() => {
                this.fetchPaymentData();
            }, 10000);
        },
        beforeUnmount() {
            // Clear polling when component is destroyed
            clearInterval(this.pollingInterval);
        },
        methods: {
            fetchPaymentData() {
                const customerId = localStorage.getItem('customerId');
                if(customerId != undefined){
                    axios.get('/api/zoho/customer-payments/' + customerId)
                    .then(response => {
                        let data = response.data;
                        this.payments = data.payments;
                    })
                    .catch(() => {
                        this.error = 'Failed to fetch payments.';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
            }

        },
    };
</script>

<style scoped>
/* Add dashboard styles here */
</style>
